import { PopinApi } from 'pleinchamp-api-client';
import { ApiConfiguration, axiosInstance } from '@api/business/api.conf';

export const PopinApiService = new PopinApi(ApiConfiguration, undefined, axiosInstance);

export function fetchPopins() {
  return PopinApiService.popin().then(data => data.data);
}
